export class FinancialProtectionModel {
    financialProtectionId: string;
    financialProtectionMessage: string;
    financialProtectionHeading: string;
    attachment: string;
    status: boolean;
   
    constructor() {
        this.financialProtectionId="";
        this.financialProtectionMessage="";
        this.financialProtectionHeading="";
        this.attachment="";
        this.status=false;
    }
}
